<template>
  <!-- 发票管理 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="发票号:" prop="invoiceNo">
                <el-input  placeholder="" v-model="searchFrom.invoiceNo"></el-input>
              </el-form-item>
               <el-form-item label="发票编号:" prop="serialNumber">
                <el-input  placeholder="" v-model="searchFrom.serialNumber"></el-input>
              </el-form-item>
              <el-form-item label="开票状态:" prop="invoiceStatus">
                <el-select  v-model="searchFrom.invoiceStatus"   placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="可开票" value="3"></el-option>
                  <el-option label="已开票" value="4"></el-option>
                  <el-option label="已邮寄" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上报状态:" prop="invoiceReportStatus">
                <el-select  v-model="searchFrom.invoiceReportStatus"   placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                 <el-option label="不上报" value="1"></el-option>
                  <el-option label="未上报" value="2"></el-option>
                  <el-option label="已上报" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务类型:" prop="invoiceType">
                <el-select  v-model="searchFrom.invoiceType"   placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="运输业务" value="1"></el-option>
                  <el-option label="快递业务" value="2"></el-option>
                  <el-option label="找车业务" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票类型:" prop="wayInvoiceType">
                <el-select  v-model="searchFrom.wayInvoiceType"   placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="增值税专用发票" value="1"></el-option>
                  <el-option label="普通发票" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货主名称:" prop="tenantName">
                <el-input  placeholder="" v-model="searchFrom.tenantName"></el-input>
              </el-form-item>
              <el-form-item label="开票企业:" prop="platformZxAccNm">
                <el-input  placeholder="" v-model="searchFrom.platformZxAccNm"></el-input>
              </el-form-item>
              <el-form-item label="开票日期:" prop="wayInvoiceDate">
                <el-date-picker
                  v-model="searchFrom.wayInvoiceDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width:350px"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="上报时间:" prop="invoiceReportTiem">
                <el-date-picker
                  v-model="searchFrom.invoiceReportTiems"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width:350px"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item btnCode="00JP004B001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item  btnCode="00JP004B002" v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item  btnCode="00JP004B003" v-if="btnFlg[2]">
            <el-button type="primary" @click="youjiFN">邮寄</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="reportFN">上报</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"   :row-class-name="tableRowClassName" height="100%"
      style="width: 100%" center border row-key="id" lazy :load="load" :tree-props="{children: 'children'}">
      <el-table-column   prop="date" width="50" label=""></el-table-column>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"  prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <div>
              <!-- <el-button type="text" size="mini" btnCode="00JP004B007" v-if="scope.row.invoiceStatus==2&&btnFlg[6]"  @click="tongguoFN(scope.row)">通过</el-button>
              <el-button type="text" size="mini" btnCode="00JP004B004" v-if="scope.row.invoiceStatus==2&&btnFlg[3]"  @click="bohuiFN(scope.row)">驳回</el-button> -->
              <el-button type="text" size="mini" btnCode="00JP004B005" v-if="scope.row.invoiceStatus!=5&&scope.row.invoiceReportStatus!=3&&!scope.row.ischildren"  @click="fapiaohaoFN(scope.row)">开票</el-button>
              <el-button type="text" size="mini" btnCode="00JP004B006" v-if="btnFlg[5]&&!scope.row.ischildren&&scope.row.invoiceType==1"    @click="daochuFN(scope.row)" :disabled="isDisable">运费清单</el-button>
              <el-button type="text" size="mini" btnCode="00JP004B006" v-if="btnFlg[5]&&!scope.row.ischildren&&scope.row.invoiceType==1"    @click="daochu1FN(scope.row)" :disabled="isDisable">服务费清单</el-button>
              <el-button type="text" size="mini" btnCode="00JP004B006" v-if="btnFlg[5]&&!scope.row.ischildren&&scope.row.invoiceType==1"    @click="daochu2FN(scope.row)" :disabled="isDisable">合计清单</el-button>
              <el-button type="text" size="mini" btnCode="00JP004B006" v-if="btnFlg[5]&&scope.row.invoiceType!=1&&!scope.row.ischildren"    @click="daochu3FN(scope.row)" :disabled="isDisable">清单</el-button>
              <el-button type="text" size="mini" v-if="btnFlg[7]&&scope.row.invoiceStatus!=1&&!scope.row.ischildren"    @click="lookfapiaoFN(scope.row)" >查看发票</el-button>
              <el-button type="text" size="mini"  v-if="btnFlg[8]&&scope.row.invoiceStatus!=1&&!scope.row.ischildren" :disabled="isDisable"    @click="xiazaifapiaoFN(scope.row)" >下载发票</el-button>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="开票信息" width="90">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="006P009B002"  v-if="!scope.row.ischildren"   @click="chakanFN(scope.row)">查看</el-button>
              <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column property="orderNum" label="单据数量">
          <template scope="scope">
               <el-button type="text" size="mini" btnCode="006P009B003" v-if="!scope.row.ischildren"    @click="danjuFN(scope.row)">{{scope.row.orderNum}}</el-button>
               <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="发票编号"  width="200"  property="serialNumber" :formatter="emptyFn">
          <template slot-scope="scope">
              <span type="text" size="mini" v-if="!scope.row.ischildren">{{scope.row.serialNumber}}</span>
              <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column property="invoiceStatus" label="开票状态"  width="150">
          <template scope="scope">{{[ "待开票", "处理中", "可开票", "已开票", "已邮寄"][scope.row.invoiceStatus-1]}}</template>
        </el-table-column>
        <el-table-column property="invoiceReportStatus" label="上报状态"  width="150">
          <template scope="scope">{{[ "不上报", "未上报", "已上报"][scope.row.invoiceReportStatus-1]}}</template>
        </el-table-column>
        <el-table-column property="invoiceType" label="业务类型"  width="150">
          <template scope="scope">{{[ "运输业务", "快递业务","找车业务"][scope.row.invoiceType-1]}}</template>
        </el-table-column>
        <el-table-column property="wayInvoiceType" label="发票类型" width="170">
          <template scope="scope">{{[ "增值税专用发票", "普通发票" ][scope.row.wayInvoiceType-1]}}</template>
        </el-table-column>
        <el-table-column property="wayInvoiceSign"  width="120"  label="有效标志">
          <template scope="scope">
            <span v-if="scope.row.wayInvoiceSign == 'Y'">有效</span>
            <span v-else-if="scope.row.wayInvoiceSign == 'N'">作废</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column property="tenantName"  width="270"  :formatter="emptyFn"   label="货主名称"></el-table-column>
        <el-table-column property="platformZxAccNm"  width="270"  :formatter="emptyFn"   label="开票企业"></el-table-column>
        <el-table-column label="发票税率"  width="120"  property="wayAxrate" :formatter="emptyFn"></el-table-column>
        <el-table-column property="wayMoney"  width="120"  :formatter="emptyFn"   label="发票金额(元)"></el-table-column>
        <el-table-column property="issuingOffice"  width="120"  :formatter="emptyFn"   label="开票单位"></el-table-column>
        <el-table-column property="wayInvoiceCode"  width="200"  :formatter="emptyFn"   label="发票代码"></el-table-column>
        <el-table-column property="wayInvoiceNo"  width="200"  :formatter="emptyFn"   label="发票号"></el-table-column>
        <el-table-column property="wayInvoiceMonth"  width="200"  :formatter="emptyFn"   label="发票所属月份"></el-table-column>
        <el-table-column property="expressCompany"  width="200"  :formatter="emptyFn"   label="快递公司"></el-table-column>
        <el-table-column property="expressNo"  width="200"  :formatter="emptyFn"   label="快递单号"></el-table-column>
        <el-table-column property="createTime"  width="170"  :formatter="dateTimeFormat"   label="打包时间"></el-table-column>
        <el-table-column width="170" property="wayInvoiceDate" :formatter="dateFormat" label="开票日期"></el-table-column>
        <el-table-column width="170" property="postageTime" :formatter="dateTimeFormat" label="邮寄时间"></el-table-column>
        <el-table-column width="170" property="invoiceReportTiem" :formatter="dateTimeFormat" label="上报时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

   <!-- 开具发票  -->
    <el-dialog  title="开具发票"  :visible.sync="dialogFPH" width="1200px"  class="kaipiaoBox" :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="fphFrom" ref="fphFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div style="display: flex;justify-content: space-between;margin-top:12px">
           <h4 class="titleBox">开票主体：{{CKfrom.tenantName}}</h4>
           <h4 style="margin:0;color: #0e6eec;">{{[ "待开票", "处理中", "可开票", "已开票", "已邮寄"][CKfrom.invoiceStatus-1]}}</h4>
        </div>
        <hr>
        <h4 class="titleBox" style="margin-bottom:12px">开票信息</h4>
        <div class="box1">
          <div class="box11">
            <p class="name">发票抬头</p>
            <p class="cont">{{CKfrom.tenantName}}</p>
          </div>
          <div  class="box11">
            <p class="name">统一社会信用代码</p>
            <p class="cont">{{CKfrom.taxpayerNumber}}</p>
          </div>
          <div  class="box11">
            <p class="name">开户银行名称</p>
            <p class="cont">{{CKfrom.openingBank}}</p>
          </div>
          <div  class="box11">
            <p class="name">基本开户账户</p>
            <p class="cont">{{CKfrom.bankAccount}}</p>
          </div>
          <div  class="box11">
            <p class="name">注册场所地址</p>
            <p class="cont">{{CKfrom.registAddress}}</p>
          </div>
          <div  class="box11">
            <p class="name">注册固定电话</p>
            <p class="cont">{{CKfrom.registPhone}}</p>
          </div>
        </div>
        <hr>
        <div style="display: flex;justify-content: space-between;margin:12px 0;">
           <h4 class="titleBox">发票明细</h4>
           <h4  style="margin:0;"> <el-button type="text" size="mini" btnCode="006P009B002"  :disabled="isDisable"   @click="mingxidaochuFN()">下载明细</el-button></h4>
        </div>
        <el-table :data="FPMXlist"    ref="FPMXlist" v-loading="loading"   bordersize="mini"  height="180" style="width: 100%" center border>
          <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
          <el-table-column property="orderNo"  width="200"  :formatter="emptyFn"   label="订单编号"></el-table-column>
          <el-table-column property="wayNo"  width="200"  :formatter="emptyFn"   label="运单编号"></el-table-column>
          <el-table-column property="pricingMethodName"  width="120"  :formatter="emptyFn"   label="运单编号"></el-table-column>
          <el-table-column property="unitPrice"  width="120"     label="单价"></el-table-column>
          <el-table-column property="weightAndUnitMeasurement"  width="120"    label="结算量"></el-table-column>
          <el-table-column property="wayMoney"  width="120"  :formatter="emptyFn"   label="运费(元)"></el-table-column>
          <el-table-column property="serviceAxrate"  width="120"  :formatter="emptyFn"   label="税s率(%)"></el-table-column>
          <el-table-column property="serviceMoney"  width="120"  :formatter="emptyFn"   label="服务费(元)"></el-table-column>
          <el-table-column property="totalAmount"  width="120"  :formatter="emptyFn"   label="合计(元)"></el-table-column>
          <el-table-column width="170" property="settlementTime"  label="付款时间"></el-table-column>
          <el-table-column property="vhcNo"  width="200"  :formatter="emptyFn"   label="车牌号"></el-table-column>
          <el-table-column property="vehicleType"  width="200"  :formatter="emptyFn"   label="车辆类型"></el-table-column>
          <el-table-column property="productTypeName"  width="200"  :formatter="emptyFn"   label="货品名称"></el-table-column>
          <el-table-column property="origin"  width="200"  :formatter="emptyFn"   label="起运地"></el-table-column>`
          <el-table-column property="destination"  width="200"  :formatter="emptyFn"   label=" 到达地"></el-table-column>
        </el-table>
        <hr>
        <h4 class="titleBox" style="margin-bottom:12px">开票详情</h4>
        <div class="inpBox" style="display: flex;">
          <div style="flex-shrink: 0; margin-right: 29px;">
            <el-form-item prop="wayInvoiceType" label="发票上传:">
              <el-upload
                class="upload-demo"
                drag
                action=""
                :auto-upload=false
                :file-list="filelist"
                :on-change="imgPreview"
                :on-remove="handleRemove"
                accept=".pdf"
                :class="[fileIsAdd?'hidden':'']"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </el-form-item>
          </div>
          <div class="box2">
            <el-form-item  label="发票代码:">
              <el-input  placeholder=""  v-model="fphFrom.wayInvoiceCode"></el-input>
            </el-form-item>
            <el-form-item prop="wayInvoiceNo" label="发票号:">
              <el-input  placeholder=""  maxlength="30" v-model="fphFrom.wayInvoiceNo"></el-input>
            </el-form-item>
            <el-form-item label="开票日期:" prop="wayInvoiceDate">
              <el-date-picker
                      v-model="fphFrom.wayInvoiceDate"
                      format="yyyy-MM-dd"
                      value-format="timestamp"
                      type="date"
                      placeholder="选择日期"
                      @change="wayDate">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发票所属月份:" prop="wayInvoiceMonth" class="month">
              <el-input  placeholder=""  v-model="fphFrom.wayInvoiceMonth"  :readonly="true"
                  class="disabled">
              </el-input>
            </el-form-item>
            <el-form-item prop="wayInvoiceSign" label="有效标志:">
              <el-radio-group v-model="fphFrom.wayInvoiceSign" style="width:200px;">
                <el-radio label="Y">有效</el-radio>
                <el-radio label="N">作废</el-radio>
              </el-radio-group>
              <!-- <el-select v-model="fphFrom.wayInvoiceSign" placeholder="请选择" @change="$forceUpdate()">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item prop="wayInvoiceType" label="发票类型">
              <el-radio-group v-model="fphFrom.wayInvoiceType">
                <el-radio :label="1">增值税专用发票</el-radio>
                <el-radio :label="2">普通发票</el-radio>
              </el-radio-group>
              <!-- <el-select v-model="fphFrom.wayInvoiceType" placeholder="请选择" @change="$forceUpdate()">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select> -->
            </el-form-item>
          </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFPH = false" class="btn1" >关闭</el-button>
        <el-button type="primary" @click="fpsaveFn()">确认</el-button>
      </span>
   </el-dialog>
   <!-- 邮寄 -->
    <el-dialog  title="邮寄"  :visible.sync="dialogYJ" width="400px"   :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="yjFrom" ref="yjFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
          <el-form-item prop="expressCompany" label="快递公司:">
               <el-input  placeholder=""    maxlength="30" v-model="yjFrom.expressCompany"  ></el-input>
          </el-form-item>
          <el-form-item prop="expressNo" label="快递单号">
               <el-input  placeholder=""    maxlength="30" v-model="yjFrom.expressNo"  ></el-input>
          </el-form-item>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogYJ = false">取消</el-button>
        <el-button type="primary" @click="saveFn('yjFrom')">确认</el-button>
      </span>
   </el-dialog>
   <!-- 驳回 -->
    <el-dialog  title="驳回"  :visible.sync="dialogTH" width="460px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true" :model="THFrom" ref="THFrom" :rules="rules"  class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
            <el-form-item label="驳回原因:" prop="examineReason" class="miaoshu">
              <el-input  type="textarea" :rows="3"  placeholder="" maxlength="100" v-model="THFrom.examineReason"></el-input>
            </el-form-item>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTH = false">取 消</el-button>
        <el-button type="primary" @click="THsave()">确 定</el-button>
      </span>
   </el-dialog>
   <!-- 查看发票明细 -->
    <el-dialog  title="发票信息"  :visible.sync="dialogCk" width="460px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
     <div>
         <div class='detilTop'>
            <p style="font-size:16px;font-weight: bold;">增值税发票开票信息&nbsp;&nbsp;&nbsp;&nbsp;</p>
            <p>单位名称：<span>{{CKfrom.companyName}}</span></p>
            <p>纳税人识别号：<span>{{CKfrom.taxpayerNumber}}</span></p>
            <p>注册地址：<span>{{CKfrom.registAddress}}</span></p>
            <p>注册电话：<span>{{CKfrom.registPhone}}</span></p>
            <p>开户行：<span>{{CKfrom.openingBank}}</span></p>
            <p>账号：<span>{{CKfrom.bankAccount}}</span></p>
            <el-divider></el-divider>
          </div>
           <div class='detilTop'>
              <p style="font-size:16px;font-weight: bold;">发票收票地址&nbsp;&nbsp;&nbsp;&nbsp;</p>
              <p>收票人姓名：<span>{{CKfrom.receiveName}}</span></p>
              <p>联系电话：<span>{{CKfrom.receiveTel}}</span></p>
              <p>电子邮箱：<span>{{CKfrom.receiveEmail}}</span></p>
              <p>收票地址：<span>{{CKfrom.province}}{{CKfrom.city}}{{CKfrom.area}}{{CKfrom.address}}</span></p>
            </div>
     </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogCk = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 单据明细 -->
    <el-dialog  title="单据明细"  :visible.sync="dialogDJMX" width="1100px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="table">
        <el-table :data="DJMXlist"  v-if="row.invoiceType==1"  ref="DJMXlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="400" style="width: 100%" center border>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="businessNo"  width="200"  :formatter="emptyFn"   label="业务编号"></el-table-column>
         <el-table-column property="publishPricingMethod" label="计价方式">
          <template scope="scope">{{[ "单价", "包干",][scope.row.pricingMethod-1]}}</template>
        </el-table-column>
         <el-table-column property="unitPrice" width="100"     label="单价">
          <template scope="scope">
            <div>
            <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{scope.row.unitMeasurement}}</span>
            <span v-if="scope.row.pricingMethod==2">{{scope.row.unitPrice}}元/车</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="weight"  width="120"  :formatter="emptyFn"   label="结算量"></el-table-column>
       <el-table-column property="wayMoney"  width="120"  :formatter="emptyFn"   label="运费(元)"></el-table-column>
        <el-table-column label="税率(%)"  width="120" property="serviceAxrate" :formatter="emptyFn">
            <template slot-scope="scope">
              <span>{{scope.row.serviceAxrate*100}}</span>
            </template>
        </el-table-column>
         <el-table-column property="serviceMoney"  width="120"  :formatter="emptyFn"   label="服务费(元)"></el-table-column>
        <el-table-column label="合计(元)"  width="120">
            <template slot-scope="scope">
              <span style="color: #0e6eec;cursor: pointer;" >{{scope.row.totalAmount}}</span>
            </template>
        </el-table-column>
      </el-table>
       <el-table :data="DJMXlist" v-else  ref="DJMXlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="400" style="width: 100%" center border>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="businessNo"  width="200"  :formatter="emptyFn"   label="业务编号"></el-table-column>
         <el-table-column property="invoiceType" label="业务类型">
          <template scope="scope">{{[ "运输业务", "快递业务","找车业务"][scope.row.invoiceType-1]}}</template>
        </el-table-column>
        <el-table-column property="wayMoney"  width="120"  :formatter="emptyFn"   label="费用(元)"></el-table-column>
         <el-table-column width="170" property="settlementTimes" :formatter="dateTimeFormat" label="结算时间"></el-table-column>
      </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDJMX = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 查看发票 -->
    <el-dialog  title="查看发票"  :visible.sync="dialogCkFP" width="460px"  :close-oni-click-modal="false" :close-on-press-escape="false" center>
     <div>
        <p  v-for="item in filelist" :key="item.fileId"><el-button type="text" @click="lookfapiaoFN1(item.url)" >{{item.name}}</el-button></p>
     </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogCkFP = false">关闭</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, dateFormatUtil } from '@/utils/util'
import { invoiceList, invoiceUpdates, invoiceModel, listSettles, findInvoiceDetailList, upOwnerInvoice, getAllFileShow,
  invoiceReport // 上报
} from '@/api/consignment'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { fileDownAll } from '@/utils/fileDownAll.js'
export default {
  data () {
    return {
      options: [{
        value: 1,
        label: '增值税专用发票'
      }, {
        value: 2,
        label: '普通发票'
      }],
      options1: [{
        value: 'Y',
        label: '有效'
      }, {
        value: 'N',
        label: '作废'
      }],
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        notInvoiceStatusList: '[1,2]'
      },
      tableList: [],
      loading: 'false',
      total: 0,
      // 发票号/邮寄
      dialogFPH: false,
      dialogYJ: false,
      fphFrom: {},
      yjFrom: {},
      // 驳回
      dialogTH: false,
      THFrom: {},
      // 单据明细
      dialogDJMX: false,
      DJMXlist: [],
      // 查看开票信息
      dialogCk: false,
      CKfrom: {},
      addFrom: {},
      rules: {
        wayInvoiceNo: { required: true, message: '请输入运费发票号', trigger: 'blur' },
        serviceInvoiceNo: { required: true, message: '请输入服务费发票号', trigger: 'blur' },
        expressCompany: { required: true, message: '请输入快递公司', trigger: 'blur' },
        expressNo: { required: true, message: '请输入快递单号', trigger: 'blur' },
        examineReason: { required: true, message: '请输入驳回原因', trigger: 'blur' },
        wayInvoiceType: { required: true, message: '请选择运费发票类型', trigger: 'blur' },
        wayInvoiceCode: { required: true, message: '请输入运费发票代码', trigger: 'blur' },
        wayInvoiceDate: { required: true, message: '请选择运费开票日期', trigger: 'blur' },
        wayInvoiceSign: { required: true, message: '请选择有效标志', trigger: 'blur' }
      },
      isDisable: false,
      row: {},
      ids: [],
      maps: new Map(),
      filelist: [],
      fileIsAdd: false,
      picDeleteIds: [],
      FPMXlist: [],
      dialogCkFP: false, // 查看发票文件
      btnFlg: [],
      btnIdArr: ['00JP004B001', '00JP004B002', '00JP004B003', '00JP004B004',
        '00JP004B005', '00JP004B006', '00JP004B007', '00JM0b0100', '00JM0b0200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/payInvoice')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 查看发票
    lookfapiaoFN (row) {
      getAllFileShow([
        {
          businessId: row.id,
          businessType: 'owner_invoice_file'
        }
      ]).then(res => {
        if (res.length == 0) {
          this.$alert('暂无发票文件', '系统提示')
        } else if (res.length == 1) {
          let tempwindow = window.open('_blank') // 先打开页面
          tempwindow.location = res[0].filePathLook// 后更改页面地址
        } else {
          this.dialogCkFP = true
          res.forEach((item, index) => {
            let name = item.urlPrimary.split('/')
            this.$set(this.filelist, index, { status: 'ready', name: name[name.length - 1], url: item.filePathLook, fileId: item.fileId })
          })
        }
      })
    },
    // 弹框查看发票
    lookfapiaoFN1 (url) {
      let tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = url// 后更改页面地址
    },
    // 下载发票
    xiazaifapiaoFN (row) {
      getAllFileShow([
        {
          businessId: row.id,
          businessType: 'owner_invoice_file'
        }
      ]).then(res => {
        if (res.length == 0) {
          this.$alert('暂无发票文件', '系统提示')
        } else if (res.length == 1) {
          let tempwindow = window.open('_blank') // 先打开页面
          tempwindow.location = res[0].url// 后更改页面地址
        } else {
          this.isDisable = true
          fileDownAll(
            this.global.payServer + '/owner/invoice/downLoadZip',
            { id: row.id },
            row.serialNumber,
            '.zip'
          )
          setTimeout(() => {
            this.isDisable = false // 点击一次时隔两秒后才能再次点击
          }, 2000)
        }
      })
    },
    reportFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let isHQ = false
        this.ids = []
        selectData.some(item => {
          // console.log(item.invoiceReportStatus);
          if (item.invoiceReportStatus != 2) {
            this.$alert('该上报状态不可上报,请选择"未上报"状态进行上报！', '系统提示')
            isHQ = false
            return true
          } else {
            this.ids.push(item.id)
            isHQ = true
          }
        })
        if (isHQ) {
          invoiceReport({ ids: this.ids }).then(res => {
          })
        }
      }
    },
    // 下载明细
    mingxidaochuFN () {
      exportExcel(
        this.global.payServer + '/owner/invoice/exportInvoiceDetailList',
        { invoiceId: this.row.id },
        '发票明细'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    imgPreview (file, fileList) {
      this.filelist = fileList
      let fileName = file.name
      let regex = /(.pdf)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length > 9) {
          this.fileIsAdd = true
        } else {
          this.fileIsAdd = false
        }
      } else {
        fileList.pop()
        this.$alert('不支持此类型', '系统提示')
        return false
      }
    },
    // 文件上传
    handleRemove (file, fileList) {
      if (file.fileId) {
        this.picDeleteIds.push(file.fileId)
      }
      this.filelist = fileList
      if (fileList.length < 10) {
        this.fileIsAdd = false
      }
    },
    // 开具发票
    fapiaohaoFN (row) {
      this.dialogFPH = true
      this.row = row
      this.fphFrom.id = row.id
      this.fphFrom.flag = 5
      this.picDeleteIds = []
      this.filelist = []
      invoiceModel({ tenantCode: row.tenantCode }).then(res => {
        this.CKfrom = res
        this.CKfrom.tenantName = localStorage.getItem('tenantName')
        this.CKfrom.invoiceStatus = row.invoiceStatus
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
      findInvoiceDetailList({ invoiceId: row.id }).then(res => {
        this.FPMXlist = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
      if (row.invoiceStatus != 1) {
        getAllFileShow([
          {
            businessId: row.id,
            businessType: 'owner_invoice_file'
          }
        ]).then(res => {
          res.forEach((item, index) => {
            let name = item.urlPrimary.split('/')
            this.$set(this.filelist, index, { status: 'ready', name: name[name.length - 1], url: item.url, fileId: item.fileId })
          })
        })
      }
      if (!row.wayInvoiceType) {
        this.$set(this.fphFrom, 'wayInvoiceType', this.options[0].value)
      } else {
        this.$set(this.fphFrom, 'wayInvoiceType', row.wayInvoiceType)
      }
      if (!row.wayInvoiceSign) {
        this.$set(this.fphFrom, 'wayInvoiceSign', this.options1[0].value)
      } else {
        this.$set(this.fphFrom, 'wayInvoiceSign', row.wayInvoiceSign)
      }
      this.$set(this.fphFrom, 'wayInvoiceCode', row.wayInvoiceCode)
      this.$set(this.fphFrom, 'wayInvoiceNo', row.wayInvoiceNo)
      this.$set(this.fphFrom, 'wayInvoiceDate', row.wayInvoiceDate)
      this.$set(this.fphFrom, 'wayInvoiceMonth', row.wayInvoiceMonth)
      if (this.$refs['fphFrom']) {
        this.$refs['fphFrom'].clearValidate()
      }
    },
    fpsaveFn () {
      this.$refs.fphFrom.validate((valid) => {
        if (valid) {
          this.fphFrom.businessType = 'owner_invoice_file'
          this.fphFrom.businessTypeName = '货主发票文件'
          this.fphFrom.picDeleteIds = this.picDeleteIds
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify(this.fphFrom))
          this.filelist.forEach(item => {
            if (!item.fileId) {
              imgfile.append('files', item.raw)
            }
          })

          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          upOwnerInvoice(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '开票成功',
              type: 'success'
            })
            this.dialogFPH = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    wayDate (val) {
      if (val) {
        this.$set(this.fphFrom, 'wayInvoiceMonth', dateFormatUtil('yyyy-MM', val))
      } else {
        this.$set(this.fphFrom, 'wayInvoiceMonth', '')
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.ischildren) {
        return 'nocheck'
      }
    },
    load (tree, treeNode, resolve) {
      this.maps.set(tree.id, { tree, treeNode, resolve })
      let data = { ...tree }
      data.id = 'c' + data.id
      data.wayAxrate = data.serviceAxrate
      data.wayMoney = data.serviceMoney
      data.wayInvoiceNo = data.serviceInvoiceNo
      data.hasChildren = false
      data.ischildren = true
      resolve([
        data
      ])
    },
    // 查看发票信息
    chakanFN (row) {
      invoiceModel({ tenantCode: row.tenantCode }).then(res => {
        this.dialogCk = true
        this.CKfrom = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 单据数量
    danjuFN (row) {
      this.row = row
      listSettles({ invoiceId: row.id }).then(res => {
        this.DJMXlist = res
        this.dialogDJMX = true
      })
    },
    // 邮寄
    youjiFN () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let isHQ = false
        this.ids = []
        let name = selectData[0].tenantName
        selectData.some(item => {
          if (item.invoiceStatus != 4) { //
            this.$alert('该状态下的数据不能邮寄发票', '系统提示')
            isHQ = false
            return true
          } else {
            if (item.tenantName == name) {
              this.ids.push(item.id)
              isHQ = true
            } else {
              this.$alert('请选择相同的客户发票进行邮寄', '系统提示')
              isHQ = false
            }
          }
        })
        if (isHQ) {
          this.dialogYJ = true
          this.yjFrom.flag = 6
          this.yjFrom.ids = this.ids
        }
      }
    },
    // // 发票hao
    // fapiaohaoFN (row) {
    //   this.dialogFPH = true
    //   this.row = row
    //   this.fphFrom.ids = [row.id]
    //   this.fphFrom.flag = 5
    // },
    saveFn (addFrom) {
      this.$refs[addFrom].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          invoiceUpdates(this[addFrom]).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            // this.dialogFPH = false
            this.dialogYJ = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 导出
    daochuFN (row) {
      exportExcel(
        this.global.payServer + '/owner/invoice/exportFreightList',
        { id: row.id },
        '运费清单'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    daochu1FN (row) {
      exportExcel(
        this.global.payServer + '/owner/invoice/exportServiceFee',
        { id: row.id },
        '服务费清单'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    daochu2FN (row) {
      exportExcel(
        this.global.payServer + '/owner/invoice/exportInvoiceList',
        { id: row.id },
        '合计清单'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    daochu3FN (row) {
      exportExcel(
        this.global.payServer + '/owner/invoice/exportPostageList',
        { id: row.id },
        '清单'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 通过
    tongguoFN (row) {
      this.$confirm('是否执行通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        invoiceUpdates({ ids: [row.id], flag: 4 }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 驳回
    bohuiFN (row) {
      this.dialogTH = true
      this.THFrom.ids = [row.id]
      this.THFrom.flag = 3
    },
    THsave () {
      this.$refs.THFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          invoiceUpdates(this.THFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.dialogTH = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      invoiceList(searchFrom).then(res => {
        this.loading = false
        res.list.forEach(item => {
          if (this.maps.get(item.id)) {
            const { tree, treeNode, resolve } = this.maps.get(item.id)
            this.load(item, treeNode, resolve)
          }
        })
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        notInvoiceStatusList: '[1,2]'
      },
      this.fphFrom = {

      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
      this.fphFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
// .inpBox .el-date-editor{
//       width: 350px!important;
// }
/deep/.nocheck .el-checkbox{
  display: none;
}
/deep/.inpBox .el-date-editor .el-input__inner {
    width: 150px;
}
/deep/.month .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}

.titleBox{
  margin:0;
}
.box1{
  display: flex;
  .box11{
    width: 16%;
    font-size: 12px;
  }
}
.cont{
  font-weight: bold;
   margin: 0;
   margin-bottom: 8px;
}
.name{
  color: #999;
   margin: 0;
   margin-bottom: 4px;
}
.kaipiaoBox{
  /deep/.el-dialog__body{
    color: #333;
  }
}
/deep/.dialog-footer{
  .el-button{
        padding: 10px 34px;
  }
  .btn1{
    border: 1px solid #0e6eec;
    color:#0e6eec;
  }
}
.box2{
  /deep/ .el-input__inner {
    width: 200px;
  }
  /deep/.el-date-editor .el-input__inner {
    width: 200px;
  }
}
/deep/.el-upload-dragger{
  width: 312px;
  height: 125px;
}
/deep/.el-upload-dragger .el-icon-upload{
    margin: 20px 0 16px;
}
.hidden /deep/.el-upload--text{
  display: none;
}
</style>
